import axios from '../axios';
import endpoints from '../../utils/constants/endpoints';
import RequestHeaders from '../../enums/RequestHeaders';
import type { StreamEntitySlug } from './entities';
import type { StreamUpdateResponse } from './types';

interface StreamUpdateRequestOptions {
  entity: StreamEntitySlug;
  updateToken?: string;
  workspaceId?: string;
  // Restart the stream (no updateToken) while keeping local rows, so the server also delivers
  // deletions that happened while the cursor was dead.
  resync?: boolean;
}

const getStreamUpdatesByEntity = async ({
  entity,
  updateToken = '',
  workspaceId,
  resync = false,
}: StreamUpdateRequestOptions): Promise<StreamUpdateResponse> => {
  const headers: Record<string, string> = {};

  if (typeof window === 'undefined') {
    headers['Accept-Encoding'] = 'br';
  }

  if (workspaceId) {
    headers[RequestHeaders.WORKSPACE_ID] = workspaceId;
  }

  const url = `${endpoints.stream.updatesV3}/${entity}?update_token=${encodeURIComponent(
    updateToken
  )}${resync ? '&resync=true' : ''}`;

  const { data } = await axios.get<StreamUpdateResponse>(url, { headers });

  return data;
};

export default getStreamUpdatesByEntity;
